import { AfterContentInit, AfterViewInit, Component, ContentChildren, CUSTOM_ELEMENTS_SCHEMA, Directive, ElementRef, EventEmitter, Input, NgModule, NO_ERRORS_SCHEMA, OnChanges, Output, QueryList, Renderer2, SimpleChanges } from "@angular/core";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { SelectModule, DatePickerModule } from 'primeng/primeng';

import { SelectModule } from "primeng/select";
import { DatePickerModule } from "primeng/datepicker";
import { TooltipModule } from "primeng/tooltip";
import { ToastModule } from "primeng/toast";
import { MultiSelectModule } from "primeng/multiselect";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ProgressBarModule } from "primeng/progressbar";
import { AutoCompleteModule } from "primeng/autocomplete";
import { StepsModule } from "primeng/steps";
import { AccordionModule } from "primeng/accordion";
import { RadioButtonModule } from "primeng/radiobutton";
import { CheckboxModule } from "primeng/checkbox";
import { TreeModule } from "primeng/tree";
import { PanelModule } from "primeng/panel";
import { MenuModule } from "primeng/menu";
import { SelectButtonModule } from "primeng/selectbutton";
import { ToggleSwitchModule as InputSwitchModule } from "primeng/toggleswitch";
import { ToggleButtonModule } from "primeng/togglebutton";
import { UploadProgressComponent } from "../shared-components/upload-progress/upload-progress.component";
import { HeaderComponent } from "../shared-components/header/header.component";

@Component({
  selector: "p-tabPanel, p-tabpanel",
  template: '<div class="p-tabview-panel" [hidden]="!active"><ng-content></ng-content></div>',
  standalone: false
})
export class LegacyTabPanelComponent {
  @Input() header = "";
  @Input() disabled = false;
  @Input() inputId = "";
  @Input() tooltip = "";
  active = false;
}

@Component({
  selector: "p-tabView, p-tabs-legacy",
  template: `
    <div class="p-tabview p-component">
      <ul class="p-tabview-nav">
        <li
          *ngFor="let panel of panels; let i = index"
          [class.p-highlight]="i === activeIndex"
          [attr.id]="panel.inputId || null"
          [attr.title]="panel.tooltip || null"
          (click)="select(i)">
          <button type="button" class="p-tabview-nav-link" [disabled]="panel.disabled">
            {{ panel.header }}
          </button>
        </li>
      </ul>
      <div class="p-tabview-panels"><ng-content></ng-content></div>
    </div>
  `,
  standalone: false
})
export class LegacyTabViewComponent implements AfterContentInit, OnChanges {
  @Input() activeIndex = 0;
  @Output() activeIndexChange = new EventEmitter<number>();
  @Output() onChange = new EventEmitter<{ index: number }>();
  @ContentChildren(LegacyTabPanelComponent) panels!: QueryList<LegacyTabPanelComponent>;

  ngAfterContentInit() {
    this.updateActivePanel();
    this.panels.changes.subscribe(() => this.updateActivePanel());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["activeIndex"] && this.panels) this.updateActivePanel();
  }

  select(index: number) {
    if (this.panels.get(index)?.disabled) return;
    this.activeIndex = index;
    this.updateActivePanel();
    this.activeIndexChange.emit(index);
    this.onChange.emit({ index });
  }

  private updateActivePanel() {
    this.panels?.forEach((panel, index) => panel.active = index === this.activeIndex);
  }
}

@Directive({
  selector: "p-radioButton[label], p-radiobutton[label]",
  standalone: false
})
export class LegacyRadioButtonLabelDirective implements AfterViewInit, OnChanges {
  @Input() label = "";
  private labelElement: any;

  constructor(private readonly elementRef: ElementRef, private readonly renderer: Renderer2) {}

  ngAfterViewInit() {
    this.labelElement = this.renderer.createElement("label");
    this.renderer.addClass(this.labelElement, "p-radiobutton-label");
    const inputId = this.elementRef.nativeElement.getAttribute("inputId");
    if (inputId) this.renderer.setAttribute(this.labelElement, "for", inputId);
    this.renderer.appendChild(this.labelElement, this.renderer.createText(this.label));
    this.renderer.appendChild(this.elementRef.nativeElement, this.labelElement);
  }

  ngOnChanges() {
    if (this.labelElement) this.renderer.setProperty(this.labelElement, "textContent", this.label);
  }
}

@NgModule({
  declarations:[LegacyTabViewComponent, LegacyTabPanelComponent, LegacyRadioButtonLabelDirective],

  imports: [
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    BrowserAnimationsModule,
    SelectModule,
    DatePickerModule,
    TooltipModule,
    MultiSelectModule,
    ScrollPanelModule,
    ProgressBarModule,
    AutoCompleteModule,
    ToastModule,
    StepsModule,
    RadioButtonModule,
    CheckboxModule,
    AccordionModule,
    TreeModule,
    PanelModule,
    MenuModule,
    SelectButtonModule,
    InputSwitchModule,
    ToggleButtonModule,
  ],
  exports: [
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    BrowserAnimationsModule,
    SelectModule,
    DatePickerModule,
    TooltipModule,
    MultiSelectModule,
    ScrollPanelModule,
    ProgressBarModule,
    AutoCompleteModule,
    ToastModule,
    StepsModule,
    RadioButtonModule,
    CheckboxModule,
    AccordionModule,
    TreeModule,
    PanelModule,
    MenuModule,
    SelectButtonModule,
    InputSwitchModule,
    ToggleButtonModule,
    LegacyTabViewComponent,
    LegacyTabPanelComponent,
    LegacyRadioButtonLabelDirective,
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class PrimeNGModule {}
